const storageKey = 'levitate.ssoAttemptAddress';

// Storage can be blocked (private mode, site settings); losing the pre-fill must never stop a sign-in.
const withStorage = <T>(use: (storage: Storage) => T, fallback: T): T => {
	try {
		return use(window.sessionStorage);
	} catch {
		return fallback;
	}
};

export const rememberSsoAttemptAddress = (address: string | undefined) =>
	withStorage(storage => {
		if (address) {
			storage.setItem(storageKey, address);
		} else {
			storage.removeItem(storageKey);
		}
	}, undefined);

export const forgetSsoAttemptAddress = () => withStorage(storage => storage.removeItem(storageKey), undefined);

export const takeSsoAttemptAddress = (): string | undefined =>
	withStorage(storage => {
		const address = storage.getItem(storageKey);
		storage.removeItem(storageKey);
		return address || undefined;
	}, undefined);
